export class Country {
    countryId: number;
    displayName: string;
    countryPhoneCode:string;
    countryReference:string;
    name: string;
}
